import { Box, Grid } from "@mui/material";
// import RootComponents from "../../components/common/RootComponents";
import RecruiterProfile from "../../components/containers/RecruiterProfile";
// import CommonCard from "../../components/common/CommonCard";
import styles from "./Dashboard.module.css";
import JobPostView from "../../components/common/JobPostView";
import profile_image from "../../assets/images/ajit_image.jpeg";
import TableCard from "../../components/common/TableCard";
import { PiChatsFill } from "react-icons/pi";
import { LiaHeadsetSolid } from "react-icons/lia";
import { GoChecklist } from "react-icons/go";
import { BsFileEarmarkText } from "react-icons/bs";
import { BsFillJournalBookmarkFill } from "react-icons/bs";

const Dashboard = () => {
  return (
    // <RootComponents>
    <>
      <Box
        className={styles.requiter_profile_section}
        sx={{ backgroundColor: "#fff" }}
      >
        <RecruiterProfile />

        <Grid container sx={{ padding: "0 15px 15px 15px" }}>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <TableCard
              image={
                <BsFileEarmarkText
                  className="card_icons"
                  style={{ height: "32px" }}
                />
              }
              count="200 "
              text="Requirements "
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <TableCard
              image={<GoChecklist className="card_icons" />}
              count="75"
              text="Submissions"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <TableCard
              image={<LiaHeadsetSolid className="card_icons" />}
              count="15"
              text="Interviews  "
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <TableCard
              image={<PiChatsFill className="card_icons" />}
              count="15"
              text="Feedback Pending  "
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <TableCard
              image={
                <BsFillJournalBookmarkFill
                  className="card_icons"
                  style={{ fontSize: "29px" }}
                />
              }
              count="10"
              text="Placement "
            />
          </Grid>
        </Grid>
      </Box>
      <Box className={styles.requiter_profile_section}>
        <JobPostView
          image={profile_image}
          position="Lead Java Developer"
          price="30k"
          location=" Kolkata India"
          hiring="Full Time"
          btn1="520 Reach"
          btn2="View"
        />
        <JobPostView
          image={profile_image}
          position="Lead Java Developer"
          price="30k"
          location="Kolkata India"
          hiring="Contract 12 Months"
          btn1="30 Reach"
          btn2="View"
        />
        <JobPostView
          image={profile_image}
          position="Lead Java Developer"
          price="30k"
          location="Kolkata India"
          hiring="Contract 12 Months"
          btn1="Closed"
          btn2="View"
        />
        <JobPostView
          image={profile_image}
          position="Lead Java Developer"
          price="30k"
          location="Kolkata India"
          hiring="W2"
          btn1="30 Hold"
          btn2="View"
        />
      </Box>
    </>
    // </RootComponents>
  );
};

export default Dashboard;
